import { c as _c } from "react/compiler-runtime";
import { MenuItem, Select } from '@mui/material';
import { ConditionOperatorEnum, type Condition } from '@repo/api-gw-sdk';
import { PropertyPolicyRelation } from '@/types/advanceFilter';
import { inlineDropdownStyle } from './conditionComponents';
export const OPERATORS: Record<PropertyPolicyRelation, Partial<Record<ConditionOperatorEnum, {
  label: string;
}>>> = {
  [PropertyPolicyRelation.SingleValue]: {
    [ConditionOperatorEnum.In]: {
      label: 'is one of'
    },
    [ConditionOperatorEnum.NotIn]: {
      label: 'is not one of'
    }
  },
  [PropertyPolicyRelation.MultipleValues]: {
    [ConditionOperatorEnum.ContainsAnyOf]: {
      label: 'contains any of'
    },
    [ConditionOperatorEnum.Contains]: {
      label: 'contains all of'
    },
    [ConditionOperatorEnum.ContainsNoneOf]: {
      label: 'contains none of'
    }
  },
  [PropertyPolicyRelation.String]: {
    [ConditionOperatorEnum.In]: {
      label: 'is one of'
    },
    [ConditionOperatorEnum.NotIn]: {
      label: 'is not one of'
    },
    [ConditionOperatorEnum.Contains]: {
      label: 'contains'
    },
    [ConditionOperatorEnum.NotContains]: {
      label: 'does not contain'
    },
    [ConditionOperatorEnum.StartsWith]: {
      label: 'starts with'
    },
    [ConditionOperatorEnum.NotStartsWith]: {
      label: 'does not start with'
    },
    [ConditionOperatorEnum.EndsWith]: {
      label: 'ends with'
    },
    [ConditionOperatorEnum.NotEndsWith]: {
      label: 'does not end with'
    }
  },
  [PropertyPolicyRelation.Tags]: {
    [ConditionOperatorEnum.Contains]: {
      label: 'includes'
    },
    [ConditionOperatorEnum.NotContains]: {
      label: 'does not include'
    }
  },
  [PropertyPolicyRelation.Boolean]: {
    [ConditionOperatorEnum.In]: {
      label: 'detected'
    },
    [ConditionOperatorEnum.NotIn]: {
      label: 'not detected'
    }
  }
};
interface OperatorSelectProps {
  condition: Condition;
  propertyRelation: PropertyPolicyRelation;
  onChange: (condition: Condition) => void;
}
export function OperatorSelect(t0) {
  const $ = _c(11);
  const {
    condition,
    propertyRelation,
    onChange
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...inlineDropdownStyle,
      height: "100%"
    };
    t2 = {
      disablePortal: true
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = condition.operator ?? "";
  let t4;
  if ($[2] !== condition || $[3] !== onChange) {
    t4 = event => onChange({
      ...condition,
      operator: event.target.value,
      value: []
    });
    $[2] = condition;
    $[3] = onChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== propertyRelation) {
    t5 = Object.entries(OPERATORS[propertyRelation]).map(_temp);
    $[5] = propertyRelation;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <Select sx={t1} MenuProps={t2} value={t3} onChange={t4}>{t5}</Select>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(t0) {
  const [key, value] = t0;
  return <MenuItem key={key} value={key}>{value.label}</MenuItem>;
}